module.exports = __webpack_public_path__ + "static/img/6.0a8381a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/zncy/zncajzx/6.png
// module id = nwhJ
// module chunks = 1